/** @file The importable layers of a source: PSD pixel layers (groups and empty layers left out) or PNG files. */
import type { ImportSource, LayerChoice } from './importTypes';

/** Bottom-to-top; PSD layers hidden in the file start unchecked, PNG files start checked at (0, 0). */
export function layerChoices(source: ImportSource): LayerChoice[] {
  if (source.kind === 'png') {
    return source.files.map((f, index) => ({ index, name: f.name, path: f.name, x: 0, y: 0, width: f.width, height: f.height, hidden: false, checked: true }));
  }
  return source.session.layers
    .filter((l) => (l.kind === 'raster' || l.kind === 'text') && l.width * l.height > 0)
    .map((l) => ({ index: l.index, name: l.name, path: l.path, x: l.x, y: l.y, width: l.width, height: l.height, hidden: l.hidden, checked: !l.hidden }));
}
